/**
 * StepOne Component
 *
 * Features:
 * - Handles PDF file upload and validation for activity submission.
 * - Displays file name, validation icons, and error messages.
 * - Uses i18next for translations.
 * - Utilizes Material-UI Button and Icon components for UI.
 * - Calls archiveHandler and uploadButtonEnabled via props for parent communication.
 */
import { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Dropzone from 'react-dropzone';
import Button from '@mui/material/Button';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ClearIcon from '@mui/icons-material/Clear';

import classes from './StepOne.module.css';

const StepOne = props => {
  const { t } = useTranslation(['lesson']);
  const [validatePDFInput, setValidatePDFInput] = useState('');
  const [typeArchiveNot, setTypeArchiveNot] = useState(false);
  const [message, setMessage] = useState(false);
  const [namePDF, setNamePDF] = useState('');

  const onDrop = filesOnDrop => {
    if (filesOnDrop[0]) {
      let file = null;
      file = filesOnDrop[0].name;
      file.toString();
      file = file.replace(/[^a-z0-9.]+/gi, '_').toLowerCase();
      setNamePDF(file);

      if (file != '') {
        setValidatePDFInput(true);
        setMessage('');
        setTypeArchiveNot(false);
        props.archiveHandler(filesOnDrop[0]);
      }

      if (filesOnDrop[0].size > 5242880) {
        setTypeArchiveNot(true);
        setMessage('El archivo no debe de pesar más de 5MB');
        props.uploadButtonEnabled(true);
      }
    } else {
      setTypeArchiveNot(true);
      setMessage('Solo se aceptan archivos con extensión ".pdf"');
      props.uploadButtonEnabled(true);
    }
  };

  return (
    <>
      <figure className={classes.stepNumber}>
        <img
          className={classes.numberImg}
          src="https://d1g6c01s9ssd7h.cloudfront.net/img/imageNumberActivity01.png"
          alt="number"
        />
      </figure>
      <p className={classes.titleActivity}>{t('upload_pdf_file')}</p>
      <p className={classes.descriptionActivity}>
        {t('completed_activity')}
      </p>
      <div className={classes.dropzoneContainer}>
        <Dropzone
          className={
            typeArchiveNot ? classes.dropzoneError : classes.dropzone
          }
          onDrop={onDrop}
          accept=".pdf"
        >
          <div className={classes.containerButtons}>
            <Button
              variant="contained"
              className={classes.buttonSave}
            >
              <AttachFileIcon className={classes.iconBtn} />
              {t('attach_file')}
            </Button>
          </div>
          <div className={classes.contentTextfield}>
            <input
              value={namePDF}
              className={classes.inputPdf}
              readOnly
            />
            {validatePDFInput ? (
              <CheckCircleOutlineIcon
                className={classes.iconValidationCorrect}
              />
            ) : (
              <ClearIcon
                className={classes.iconValidationIncorrect}
              />
            )}
          </div>
          <div className={classes.contentTextMessage}>
            <p className={classes.textMessage}>{message}</p>
          </div>
        </Dropzone>
      </div>
    </>
  );
};

StepOne.propTypes = {
  /**
   * Function to enable/disable the upload button
   */
  uploadButtonEnabled: PropTypes.func,
  /**
   * Function to handle the uploaded archive (PDF file)
   */
  archiveHandler: PropTypes.func
};

StepOne.defaultProps = {
  uploadButtonEnabled: () => {},
  archiveHandler: () => {}
};

export default StepOne;
